import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { useApplicationContext } from '../../../modules/context/ApplicationContext/ApplicationContext';
import {
  GlobalSearchProductCodeParams,
  SearchResultGroup,
} from '../../../modules/global-search/globalSearch.types';
import { getGlobalSearchProductCodeKey } from './globalSearchProductCode.keys';
import { findGlobalSearchProductCode } from './globalSearchProductCode.repository';

const STALE_TIME_MS = 30_000;

export const useGlobalSearchProductCodeQuery = (
  params: GlobalSearchProductCodeParams,
  options?: UseDataQueryOptions,
) => {
  const { brandId } = useApplicationContext();

  return useDataQuery<SearchResultGroup>(
    {
      queryKey: getGlobalSearchProductCodeKey(params, brandId),
      queryFn: async (context) => {
        const response = await findGlobalSearchProductCode(params, context?.signal);
        if (!response.ok || !response.data) {
          throw (
            response.originalError ??
            new Error('failed to fetch global search product code results')
          );
        }
        return response.data;
      },
      staleTime: STALE_TIME_MS,
    },
    options,
  );
};
